export const headerIcons = {
  greenCityLogo: 'assets/img/logo.svg',
  bookmark: 'assets/img/icon/bookmark-default.svg',
  notification: 'assets/img/icon/notifications-default.svg',
  notificationHasNew: 'assets/img/icon/notifications-has-new.svg',
  search: 'assets/img/search.svg',
  arrowDown: 'assets/img/arrow_down.svg',
  arrowDownGreen: 'assets/img/arrow_down-green.svg',
  chat: 'assets/img/icon/chats.svg'
};

export const ubsHeaderIcons = {
  ubsAdminLogo: 'assets/admin-header/new-logo-admin.svg',
  search: 'assets/img/search.svg',
  searchIcon: 'assets/admin-header/search.svg',
  arrowDown: 'assets/img/arrow_down.svg',
  ubsLogoFooter: 'assets/admin-header/logo-footer.svg'
};
